import React, { Fragment } from 'react'
import { Row, Col, Form } from 'react-bootstrap'

const PrimaryInfectionSiteOption = (props) => {
  const {
    // 
    primaryInfectionSite,
    option,
    optionIsSelected,
    disabled,
    nestedFieldDisabled,
    required,
    // functions
    handlePrimarySiteSelect,
    getValue,
    handlePrimarySiteNestedFieldsChange,
    handlePrimarySitesBlur,
  } = props

	return (
		<Row style={{ paddingTop: "0" }} key={option.fieldName}>
			<Col xs={12} sm={12} md={8} lg={6}>
				<Form.Check
					id={option.fieldName}
					name={option.displayName}
					label={option.displayName}
					value={optionIsSelected}
					checked={optionIsSelected}
					disabled={disabled}
					onChange={handlePrimarySiteSelect}
					required={required}
				/>

				{optionIsSelected && option.textFields && option.textFields.length > 0
					?
					<Fragment>
						{option.textFields.map(textField => {
							return (
								<Row key={textField.fieldName} style={{ marginBottom: '10px' }}>
									<Col xs={10} sm={10} md={6} lg={6}>
										<Form.Label>
											{textField.displayName}
										</Form.Label>
										<Form.Control
											id={`${option.fieldName}-${textField.fieldName}`}
											key={textField.fieldName}
											className='text-option-checkbox-form'
											name={textField.fieldName}
											autoComplete={getValue(option, textField.fieldName)}
											value={getValue(option, textField.fieldName)}
											disabled={nestedFieldDisabled}
                      onChange={props.preventChange ? () => null : handlePrimarySiteNestedFieldsChange}
											placeholder={textField.displayName}
                      onBlur={props.preventChange ? () => null : () => handlePrimarySitesBlur(primaryInfectionSite)}
											required={true}
                      onClick={props.handleNestedFieldClick ? () => props.handleNestedFieldClick(primaryInfectionSite) : () => null}
										/>
									</Col>
								</Row>
							)
						})}
					</Fragment>
					:
					null
				}

				{optionIsSelected && option.selectFields && option.selectFields.length > 0
					?
					<div
						className="indented-row">
						<Form.Label>
							{option.nestedLabel}
						</Form.Label>
						<Form.Control
							autoComplete="off"
							as="select"
							name={option.nestedName}
							value={getValue(option)}
							disabled={nestedFieldDisabled}
							onChange={handlePrimarySiteNestedFieldsChange}
              onBlur={() => handlePrimarySitesBlur(primaryInfectionSite)}
							required={true}
						>
							<option value="">Please make a selection</option>
							{option.selectFields.map((selectField, index) => {
								return (
									<option
										key={`${selectField.fieldName}-${index}`}
										value={selectField.displayName}
									>
										{selectField.displayName}
									</option>
								)
							})}
						</Form.Control>
					</div>
					:
					null
				}
			</Col>
		</Row>
	)
}

export default PrimaryInfectionSiteOption